import { branch, renderComponent } from "recompose";

import CollectionsSearchForm from "./Form";
import SearchRedirect from "./SearchRedirect";

export default branch(
  props => !!props.location.search,
  renderComponent(SearchRedirect)
)(CollectionsSearchForm);
